module.exports = __webpack_public_path__ + "static/media/294307.23702cf5.png";